import * as React from 'react';

type Props = {
  onClick: any,
  iconType: string,
  actionKey: string,
}

const HeaderButton = (props: Props) => {
  const { onClick, iconType, actionKey } = props;


  const handleOnClick = (e) => {
    e.preventDefault();
    if (onClick) onClick(actionKey, e);
  };

  if (iconType === 'i-menu')
    return (
      <a href="javascript:void(null)"
         className="m__head__anch"
         onClick={handleOnClick}>
        <span className="i-menu" />
      </a>
    );

  return (
    <a href="javascript:void(null)"
       className="m__head__anch"
       onClick={handleOnClick}>
      <span className={`i ${iconType}`} />
    </a>
  )
};

export default HeaderButton;
